module.exports = "/assets/site/images/aerobic.jpg?ed3185cc3864f236a56193f30d34897f";